export class ApiBatchResponse {
    batchId: string;
    totalUnprocessed: number;
    totalCount: number;
    totalProcessed: number;
    isCanceled: boolean;
    error: Array<any>;
    hasErrors: boolean;
}


// WEBPACK FOOTER //
// ./src/app/client-core/api-response-models/api-batch-response.model.ts